export function handleGetExtension(fileName: string): FileTypes {
  const splitedFileName = fileName.split('.')
  return splitedFileName[splitedFileName.length - 1] as FileTypes
}
